import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React, { useState } from "react";
import TreffasButton from "src/components/TreffasButton";
import http from "src/utils/http";
import { useTranslation } from "react-i18next";

const BookingWarningDialog = ({
  formValues,
  setFormValues,
  setHasPending,
  setActiveStep,
  _display,
  postURL = "/api/general/individual/create-booking",
  redirectStep = 4,
}) => {
  const [isProcess, setIsProcess] = useState(false);
  const { t } = useTranslation();
  const isIframe = window.self !== window.top;

  const createBookingWithPendingSession = () => {
    setIsProcess(true);
    http
      .post(postURL, {
        ...formValues,
        booking_status: "ignore_pending",
      })
      .then((response) => {
        if (response.data.message === "success") {
          if (response.data.payment_url) {
            if (_display === "embeded" || isIframe) {
              let alink = document.createElement("a");
              alink.target = "_blank";
              alink.href = response.data.payment_url;
              alink.click();
              return;
            }

            window.location.href = response.data.payment_url;
          } else {
            setActiveStep(redirectStep);
            setFormValues({});
            setHasPending(false);
          }
        }
      })
      .catch((err) => console.log("error indi create booking:", err))
      .finally(() => setIsProcess(false));
  };

  return (
    <Dialog
      open={true}
      onClose={() => console.log(`dialog unclosable.`)}
      BackdropProps={{
        sx: {
          backgroundColor: "#333970",
          opacity: "0.8 !important",
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: "8px",
          width: {
            xs: "100%",
            md: "450px",
          },
        },
      }}
    >
      <DialogTitle>{t("booking.warning_dialog.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{
            fontSize: "14px",
            lineHeight: "24px",
          }}
        >
          {t("booking.warning_dialog.title.description")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <TreffasButton
          variant="primary"
          size="md"
          loading={isProcess}
          sx={(themes) => ({
            [themes.breakpoints.up("md")]: {
              borderRadius: "12px",
              fontSize: "14px",
            },
          })}
          onClick={() => createBookingWithPendingSession()}
        >
          {t("booking.button.yes")}
        </TreffasButton>

        <TreffasButton
          variant="secondary"
          size="md"
          sx={(themes) => ({
            [themes.breakpoints.up("md")]: {
              borderRadius: "12px",
              fontSize: "14px",
            },
          })}
          onClick={() => setHasPending(false)}
        >
          {t("booking.button.no")}
        </TreffasButton>
      </DialogActions>
    </Dialog>
  );
};

export default BookingWarningDialog;
